import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WCupRankingBootstrapComponent } from './components/wcup-ranking-bootstrap/wcup-ranking-bootstrap.component';

const routes: Routes = [
  {
    path: '',
    component: WCupRankingBootstrapComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WCupRankingRoutingModule {}
